<template>
    <div style="width: 200px;">
        <multiselect
            :value="selectedRegion"
            @input="onInput"
            :options="regions"
            :close-on-select="true"
            :showLabels="false"
            :placeholder="$t('allRegions')"
            label="display_name"
            track-by="id"
            id="region-select">
            <template slot="beforeList">
                <div class="buttonOutside"><button class="allSitesButton" @click="selectAll()">{{ $t('allRegions') }}</button></div>
            </template>
            <span slot="noResult">{{ $t('regionError') }}</span>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _ from 'lodash';

export default {
    name: 'RegionMultiSelect',
    components: {
        Multiselect
    },
    props: {
        regions: {
            type: Array,
            default() {
                return [];
            }
        },
        selectedRegionId: null
    },
    methods: {
        onInput(value) {
            this.$emit('oninput', value);
        },
        selectAll() {
            this.onInput(null);
            document.getElementById('region-select').blur();
        }
    },
    computed: {
        selectedRegion() {
            let found = _.find(this.$store.state.siteGroups, {id: this.selectedRegionId});
            if (found) {
                found = JSON.parse(JSON.stringify(found));
                if (found.display_name.length > 16) {
                    found.display_name = found.display_name.substr(0, 16) + '...';
                }
            }
            return found;
        }
    }
};
</script>

<style scoped lang="scss">
.allSitesButton {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    width: 100%;
    text-align: left;
    padding: 10px;
}
.buttonOutside:hover,
.buttonOutside:focus {
    cursor: pointer;
    background-color: #eeeeee;
}
</style>

<i18n src="../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/RegionMultiSelect.vue